import {
  required,
  isEmail,
  isNumber,
  maxLength,
  minLength,
  isAlphabet,
  isPhoneNumber,
  isPassword,
  isChecked,
  isURL,
  isValidDate,
  isValidTime,
  isGST,
  isAlphanumeric,
  isPan,
} from "./Ruls";

export const TransactionalValidation = (formName, formData) => {
  const errors = {};

  const validationRules = {
    ProjectCreate: {
      project_code: [required],
      customer_id: [required],
      project_name: [required],
    },

    OrderCreate: {
      order_no: [required],
      order_ref_no: [required],
      customer_id: [required],
      order_date: [required],
    },

    InvoiceCreate: {
      order_id: [required],
      invoice_no: [required],
      warehouse_id: [required],
    },

    InwardCreate: {
      invoice_id: [required],
    },
    ReturnInwardCreate: {
      user_id: [required],
      warehouse_id: [required],
      type: [required],
    },

    OutwardCreate: {
      contractor_id: [required],
      warehouse_id: [required],
      type: [required],
    },

    subcontractorAndCustomerCreate: {
      type: [required],
      subcontractor_role: [required],
      company_name: [required],
      contact_person_name: [required],
      contact_person_email: [isEmail],
      mobile_number: [isPhoneNumber],
      gst_no: [isGST],
      pan_no: [isPan],
    },
  };

  if (formData.user_type == 2 || formData.user_type == 3) {
    validationRules.UserCreate.user_documents = {
      document: [required],
      file: [required],
    };
  }

  if (formData.user_type == 2) {
    validationRules.UserCreate.subcontractor = {
      first_name: [required],
      last_name: [required],
      email_id: [required, isEmail],
      mobile_number: [required, isPhoneNumber],
      password: [required, isPassword],
    };
  }

  const rulesForForm = validationRules[formName];

  if (!rulesForForm) {
    return errors;
  }

  const processValidation = (rules, data, parentKey = "") => {
    for (const field in rules) {
      const fieldRules = rules[field];
      const fieldValue = data[field];
      const fullKey = parentKey ? `${parentKey}.${field}` : field;

      if (Array.isArray(fieldRules)) {
        // Validate flat fields
        for (const rule of fieldRules) {
          const errorMessage = rule(fieldValue, field);
          if (errorMessage) {
            errors[fullKey] = errorMessage;
            break;
          }
        }
      } else if (Array.isArray(fieldValue)) {
        // Special case for arrays like multiModule
        fieldValue.forEach((row, index) => {
          // Process each object in the array
          processValidation(fieldRules, row, `${fullKey}[${index}]`);
        });
      } else if (typeof fieldRules === "object") {
        // Recurse into nested objects
        processValidation(fieldRules, fieldValue || {}, fullKey);
      }
    }
  };

  processValidation(rulesForForm, formData);

  return errors;
};
